import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { Card, CardTitle } from './ui/card';
import { Input } from './ui/input';

/** Shows a freshly created invitation link once, with copy and (on phones) share buttons. */
export function InviteLink({ url, name }: { url: string; name: string }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const canShare = typeof navigator.share === 'function';

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
    } catch {
      // Clipboard blocked: the link stays selectable in the field.
    }
  }

  return (
    <Card className="flex flex-col gap-3 border-accent">
      <CardTitle>{t('invite.linkTitle')}</CardTitle>
      <p className="text-sm text-muted">{t('invite.linkIntro', { name })}</p>
      <Input
        readOnly
        value={url}
        aria-label={t('invite.linkTitle')}
        onFocus={(e) => e.currentTarget.select()}
        dir="ltr"
      />
      <div className="flex flex-wrap gap-2">
        <Button onClick={() => void copy()}>
          {copied ? t('common.copied') : t('common.copy')}
        </Button>
        {canShare && (
          <Button
            variant="secondary"
            onClick={() =>
              void navigator
                .share({ title: t('app.name'), text: t('invite.shareText'), url })
                .catch(() => undefined)
            }
          >
            {t('common.share')}
          </Button>
        )}
      </div>
    </Card>
  );
}
